export const getAttributeDataLegacy = (attributes = [], attrKey) => {
    let attribute = { key: attrKey };
    let attrFound = false;
    const attrsLen = attributes.length;
    let count = 0;

    if (attrsLen > 0) {
        do {
            const attr = attributes[count];

            if (attr.key === attrKey) {
                attrFound = true;
                attribute = attr;
            }
            count += 1;
        } while (count < attrsLen && !attrFound);
    }

    return attribute;
};

export const getAttributeData = (attributes = [], attrKey) => {
    if (!attributes.find) {
        return getAttributeDataLegacy(attributes, attrKey);
    }

    return attributes.find((attr) => attr.key === attrKey) || { key: attrKey };
};

export const setCSSVars = (variables, options) => {
    const { rootElement } = options ?? {};
    const element = rootElement ?? document.documentElement;

    Object.getOwnPropertyNames(variables ?? {}).forEach((varName) => {
        element.style.setProperty(varName, variables[varName]);
    });
};

export const setSpecificCSSVar = (cssVar, value) => {
    const variables = {
        [cssVar]: value,
    };

    setCSSVars(variables);
};
